export default "<div class=\"container\">\r\n  <h1 aria-live=\"polite\">\r\n    Error Page\r\n  </h1>\r\n</div>\r\n"